<template>
  <v-container>
    <v-form>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit User</v-toolbar-title>
          <slot name="header"></slot>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="value.givenName"
                  label="Given Name"
                  name="givenName"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="value.surname"
                  label="Surname"
                  name="surname"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="value.employeeNumber"
                  label="Employee Number"
                  name="employeeNumber"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="value.department"
                  label="Department"
                  name="department"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  label="Garage Addresses"
                  item-value="id"
                  item-text="location"
                  :items="garages"
                  v-model="value.garages"
                  v-validate="'required'"
                  :error-messages="errors.collect('garages')"
                  chips
                  deletable-chips
                  name="garages"
                  required
                  multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  label="Roles"
                  item-value="id"
                  item-text="displayName"
                  :items="roles"
                  v-model="value.roles"
                  v-validate="'required'"
                  :error-messages="errors.collect('roles')"
                  chips
                  deletable-chips
                  name="roles"
                  required
                  multiple
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="value.pin"
                  label="PIN"
                  type="password"
                  v-validate="'pin|numeric'"
                  name="pin"
                  :error-messages="errors.collect('pin')"
                  :placeholder="value.hasPIN ? 'PIN - PIN Applied to Account' : 'PIN - No Current PIN Set'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="actions"></slot>
          <v-btn color="primary" :disabled="submitted || disableSubmit" @click="submit">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-overlay :value="$wait.is('loading user')" absolute>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import { VclList } from 'vue-content-loading';
import Users from './UsersClient.vue';
import GarageLocations from '../GarageLocations/GarageLocationsClient.vue';
import FormValidation from '../FormValidation.vue';

export default {
  props: {
    value: {
      required: true,
    },
    create: {
      default: false,
    }
  },
  components: {
    VclList,
  },
  mixins: [
    FormValidation,
    Users,
    GarageLocations,
  ],
  data() {
    return {
      submitted: false,
    };
  },
  created() {
    this.$validator.extend('pin', {
      validate: (pin) => {
        const errors = [];

        if (!/^\d+$/.test(pin)) {
          errors.push('Must only contain digits');
        }

        if (pin.length < 6) {
          errors.push('Must be at least 6 digits long');
        }

        if (this.hasConsecutiveSequence(pin)) {
          errors.push('Cannot contain more than 2 sequential digits');
        }

        if (this.hasRepeatingDigits(pin)) {
          errors.push('Cannot contain more than 2 repeating digits');
        }

        return { valid: errors.length === 0, data: { errors } };
      },
      getMessage: (field, params, data) => data && data.errors && data.errors.length
          ? data.errors.join(', ')
          : 'PIN is invalid'
    });
  },
  methods: {
    submitForm() {
      this.submitted = true;
      this.assign();
    },
    assign() {
      this.$emit('assign', { value: this.value });
    },
    hasConsecutiveSequence(pin) {
      for (let i = 0; i < pin.length - 2; i++) {
        if (Number(pin[i + 1]) - Number(pin[i]) === 1 &&
          Number(pin[i + 2]) - Number(pin[i + 1]) === 1) {
          return true;
        }
      }
      return false;
    },
    hasRepeatingDigits(pin) {
      for (let i = 0; i < pin.length - 2; i++) {
        if (pin[i] === pin[i + 1] && pin[i + 1] === pin[i + 2]) {
          return true;
        }
      }
      return false;
    }
},
  watch: {
    value() {
      this.submitted = false;
    },
  },
};
</script>
